import { Navigate, Outlet, Route, Routes } from "react-router-dom";

import Touchpoints from "containers/client/reviews/touchpoints/touchpoints";
import ApprovalQueue from "containers/client/reviews/approval-queue/approval-queue";
import BatchPage from "containers/client/reviews/approval-queue/batch/batch-details";

import { useFeatureFlag } from "contexts/feature-flag-context";

const ReviewsRoutes = () => {
  const isBatchManagementEnabled = useFeatureFlag("batch-management");
  const reviewsDefaultPath = isBatchManagementEnabled ? "approval-queue" : "touchpoints";

  const reviewsLayout = (
    <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
      <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
        <Outlet />
      </div>
    </div>
  );

  return (
    <Routes>
      <Route path="/" element={reviewsLayout}>
        <Route index element={<Navigate to={reviewsDefaultPath} replace />} />

        {isBatchManagementEnabled ? (
          <>
            <Route path="approval-queue" element={<ApprovalQueue />} />
            <Route path="approval-queue/batch/:id" element={<BatchPage />} />
          </>
        ) : (
          <Route path="approval-queue/*" element={<Navigate to="/reviews/touchpoints" replace />} />
        )}

        <Route path="touchpoints/*" element={<Touchpoints />} />
      </Route>
    </Routes>
  );
};

export default ReviewsRoutes;
